import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Button, Container } from "reactstrap";

function UserActiveSuspendModal(props) {
  const { open, onClose, userStatus, handleSubmit } = props;

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[9999]"
        // initialFocus={cancelButtonRef}
        onClose={() => {}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <Container
          className="fixed inset-0 z-10 overflow-y-auto mt-10"
          // onClick={onClose}
        >
          <div className="flex items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <Container className="flex justify-end items-center">
                  {/* <p className="ml-5 text-lg font-semibold">
                    Activate User Account
                  </p> */}
                  <Dialog.Title
                    as="button"
                    onClick={onClose}
                    className="text-lg font-medium leading-6 text-gray-900 text-right p-5 outline-none"
                  >
                    <AiOutlineCloseCircle />
                  </Dialog.Title>
                </Container>

                <Container className="px-5 mb-5">
                  <p
                    className={`text-xl font-semibold ${
                      userStatus.isActive === 1
                        ? "text-green-700"
                        : "text-red-700"
                    }`}
                  >
                    Are you sure you want to{" "}
                    {userStatus.isActive === 1 ? "activate" : "suspend"} this
                    user?
                  </p>
                  <p className="text-gray-400 text-sm">
                    {userStatus.isActive === 1
                      ? "Once activated, the user will be able to log in and access all permitted features."
                      : "The user will be temporarily blocked from logging in and accessing the system."}
                  </p>

                  <Container className="flex justify-end items-center gap-3 mt-3">
                    <Button
                      className={`px-5 py-[6px] border rounded-lg font-semibold active:scale-[.98] active:duration-75 transition-all ease-in-out ${
                        userStatus.isActive === 1
                          ? "text-green-600 bg-green-100 border-green-600"
                          : "text-red-600 bg-red-100 border-red-600"
                      }`}
                      onClick={handleSubmit}
                    >
                      {userStatus.isActive === 1 ? "Activate" : "Suspend"}
                    </Button>
                    <Button
                      onClick={onClose}
                      className="px-5 py-[6px] border border-gray-400 rounded-lg text-gray-600 font-semibold active:scale-[.98] active:duration-75 transition-all ease-in-out"
                    >
                      Cancel
                    </Button>
                  </Container>
                </Container>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Container>
      </Dialog>
    </Transition.Root>
  );
}

export default UserActiveSuspendModal;
